import React, { useState } from "react";

function RadioGroupFunctional({ radioOptions, defaultSelected, onChange }) {
  const [selectedValue, setSelectedValue] = useState(defaultSelected || "");

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    onChange(value);
  };

  return (
    <div>
      {radioOptions.map((option) => (
        <label key={option.id}>
          <input
            type="radio"
            value={option.value}
            checked={selectedValue === option.value}
            onChange={handleChange}
          />
          <span className="mx-2">{option.label} </span>
        </label>
      ))}
    </div>
  );
}

export default RadioGroupFunctional;



// WEBPACK FOOTER //
// ./src/component/RadioGroupFunctional.js